import actions from '../action/exchange_record'
import CONSTANT from '../constant/exchange_record'

export default {
  actions,
  state: {
    userCardList: [], // 用户卡券列表
    selectedUserCard: {}, // 选中的用户卡
    billList: [], // 卡账单
    selectedCardExchangeRecord: {}, // 选中的卡兑换记录
  },
  mutations: {
    [CONSTANT.GET_USER_CARD_LIST_SUCCESS](state, data) {
      const list = data && data.length && data.map((v) => {
        return {
          available: v.validFlag === 1 && (v.balance !== 0 || v.count !== 0), // 可用券
          unavailable: v.validFlag !== 1 || (v.balance === 0 && v.count === 0),
          ...v,
          value: v.cardNum,
          text: v.cardName
        }
      }) || []
      state.userCardList = list
    },
    [CONSTANT.GET_USER_CARD_LIST_ERROR](state, error) {
      state.userCardList = []
    },
    setSelectedUserCard(state, data) {
      state.selectedUserCard = data
    },
    setSelectedCardExchangeRecord(state, data) {
      state.selectedCardExchangeRecord = data
    },
    [CONSTANT.GET_NEW_CARD_BILL_LIST_SUCCESS](state, data) {
      state.billList = data && data.billList || []
    },
    [CONSTANT.GET_NEW_CARD_BILL_LIST_ERROR](state, error) {
      state.billList = []
    },
  }
}